import React from 'react';

const icon = () => (
  <span className="svg-icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <path d="M61 81.903a2.5 2.5 0 0 1-2.5-2.493V13.278a3.5 3.5 0 0 0-3.493-3.5H44.993a3.5 3.5 0 0 0-3.493 3.5V79.41a2.5 2.5 0 0 1-2.5 2.493 3.5 3.5 0 0 0-3.5 3.493V90.5h29v-5.103a3.5 3.5 0 0 0-3.5-3.494z" fill="#e6eaed" />
      <circle cx="50" cy="19.5" r="3" fill="none" stroke="#b1b9bf" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
      <circle cx="50" cy="76" r="2.5" fill="#b1b9bf" />
      <circle cx="50" cy="65" r="2.5" fill="#b1b9bf" />
      <circle cx="50" cy="54" r="2.5" fill="#b1b9bf" />
    </svg>
  </span>
);

export default icon;
